
import axios, { AxiosResponse } from "axios";
import AxiosService from "./Axios";
import Api from "./Api";

class FileApi {
    
    public static UPLOAD_URL = Api.URL_PREFIX + '/file/upload';

}

export default FileApi;
